import { DeliveryItemT, DeliveryTypeT } from "../types/ScheduleForm";

export const filterData = (
  data: any,
  searchTerm: string,
  type: DeliveryTypeT
): DeliveryItemT[] => {
  if (!data) return [];

  const flattenData = (obj: any): any[] => {
    if (!obj || typeof obj !== "object") return [];
    return Object.entries(obj).flatMap(([key, value]) =>
      Array.isArray(value)
        ? value.map((item) => ({ ...item, group_name: key }))
        : flattenData(value).map((item) => ({
            ...item,
            group_name: key,
          }))
    );
  };

  const flatData = Array.isArray(data) ? data : flattenData(data.data);

  const searchTerms = searchTerm
    .toLowerCase()
    .split(" ")
    .filter((term) => term.length > 0);

  const filteredData = flatData.filter((item: any) => {
    if (!item) return false;
    const searchFields = [
      item.delivery_name,
      item.delivery_id?.toString(),
      item.license_end_date,
      type === "fulfillmentGroup" ? item.group_name : "",
    ];

    const itemText = searchFields.join(" ").toLowerCase();

    return searchTerms.every((term) => itemText.includes(term));
  });

  return filteredData.sort((a, b) => {
    return (
      new Date(a.license_end_date).getTime() -
      new Date(b.license_end_date).getTime()
    );
  });
};

export function groupDataByType(
  data: DeliveryItemT[],
  type: DeliveryTypeT
): (DeliveryItemT | { name: string; items: DeliveryItemT[] })[] {
  if (type === "delivery") {
    return data;
  }

  const groupedData: { [key: string]: DeliveryItemT[] } = {};

  data.forEach((item) => {
    // use group_name for both fulfillmentGroup and customer types
    const key = item.group_name || "Ungrouped";

    if (!groupedData[key]) {
      groupedData[key] = [];
    }
    groupedData[key].push(item);
  });

  const result = Object.entries(groupedData).map(([name, items]) => ({
    name,
    items,
  }));

  return result;
}
